export const CONST_ACCESS_TOKEN = "siad.token";

export const ROLES_AVAILABLE = [
  { idrol: 1, nombre: "ADMINISTRADOR" },
  { idrol: 3, nombre: "VISITANTE" }
];

export const ROLES = [
  { idrol: 1, nombre: "ADMINISTRADOR" },
  { idrol: 2, nombre: "REGISTRADOR" },
  { idrol: 3, nombre: "VISITANTE" }
];

export const OBJ_ROLES = {
  ADMINISTRADOR: 1,
  REGISTRADOR: 2,
  VISITANTE: 3
};

// ----- Estructura del formulario -----

export const formLayout = {
  formItemLayout: {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
    }
  },
  tailFormItemLayout: {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0
      }
    }
  }
};
